/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type KillswitchBatchUserBadgesRequest = {
  userIds: Array<string>;
};

/** @internal */
export type KillswitchBatchUserBadgesRequest$Outbound = {
  user_ids: Array<string>;
};

/** @internal */
export const KillswitchBatchUserBadgesRequest$outboundSchema: z.ZodMiniType<
  KillswitchBatchUserBadgesRequest$Outbound,
  KillswitchBatchUserBadgesRequest
> = z.pipe(
  z.object({
    userIds: z.array(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      userIds: "user_ids",
    });
  }),
);

export function killswitchBatchUserBadgesRequestToJSON(
  killswitchBatchUserBadgesRequest: KillswitchBatchUserBadgesRequest,
): string {
  return JSON.stringify(
    KillswitchBatchUserBadgesRequest$outboundSchema.parse(
      killswitchBatchUserBadgesRequest,
    ),
  );
}
